import React from 'react';
import { RefinementList } from 'react-instantsearch-dom';
import sortBy from 'lodash.sortby';

import MwobFilters from './MwobFilters';
import FilterBlock from '../../elements/FilterBlock';
import HierarchicalMenuMulti from '../../elements/HierarchicalMenuMulti';

const CompanyFilters = () => (
    <>
        <FilterBlock label="Business Type">
            <div className="mb-3">
                <HierarchicalMenuMulti
                    attribute="business_type"
                    limit={99999}
                    transformItems={items => sortBy(items, ['label'])}
                />
            </div>
        </FilterBlock>

        <FilterBlock label="Country" attribute="location.country">
            <RefinementList attribute="location.country" limit={99999} />
        </FilterBlock>

        <FilterBlock label="State/Province" attribute="location.state">
            <RefinementList attribute="location.state" limit={99999} />
        </FilterBlock>

        <FilterBlock label="Global Region" attribute="location.region">
            <RefinementList attribute="location.region" limit={99999} />
        </FilterBlock>

        <MwobFilters />
    </>
);

export default CompanyFilters;
